import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrButtonModule } from '../pr-button/pr-button/pr-button.module';
import { PrGedPickerModule } from '../pr-ged-picker/ged-picker.module';
import { PrToolbarModule } from '../pr-button/pr-toolbar/pr-toolbar.module';
import { PrTableModule } from '../pr-table/pr-table.module';

import { DndDirective } from './directive/directive';

import { PrFileComponent } from './pr-file.component';

@NgModule({
  declarations: [PrFileComponent, DndDirective],
  imports: [
    CommonModule,
    PrButtonModule,
    PrGedPickerModule,
    PrTableModule,
    PrToolbarModule,
  ],
  exports: [PrFileComponent],
})
export class PrFileModule {}
